var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPufferCoatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.5,
    height: 36.867,
    viewBox: "0 0 31.5 36.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "puffer-coat",
    transform: "translate(-5.942 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11878",
    "data-name": "Path 11878",
    d: "M48.3,21.7a1.88,1.88,0,0,1-1.079.774c1.032,2.874,1.2,4.871.468,5.921a1.852,1.852,0,0,1-.273.3c.92,2.415,1.761,5.512.756,6.98a1.8,1.8,0,0,1-.354.38c.123.533.235,1.1.318,1.681,1.345-.034,3.5-.27,4.665-1.373a2.452,2.452,0,0,0,.616-.89c.94-2.352-.459-3.472-.923-3.766a6.1,6.1,0,0,1-1.962.886.313.313,0,0,1-.063.007.3.3,0,0,1-.061-.6,5.677,5.677,0,0,0,1.883-.881c1.748-1.774.681-4.3.171-5.252a6.893,6.893,0,0,1-2.3,1.541.3.3,0,0,1-.1.016.3.3,0,0,1-.1-.589A6.686,6.686,0,0,0,52.195,25.3a.3.3,0,0,1,.039-.146,4.135,4.135,0,0,0-.325-4.792,7.328,7.328,0,0,1-1.667,1.573.292.292,0,0,1-.166.05.3.3,0,0,1-.166-.554A7.1,7.1,0,0,0,51.584,19.8c-.033-3.163-2.37-5.123-4.448-6.241,1.2,2.954,2.245,6.5,1.168,8.137Z",
    transform: "translate(-16.297 -4.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11879",
    "data-name": "Path 11879",
    d: "M42.2,33.948c.429-.618.666-2.073-.574-5.475-.059,0-.111.016-.173.016H34.5v6.044h6.346A1.513,1.513,0,0,0,42.2,33.948Z",
    transform: "translate(-11.298 -10.671)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11880",
    "data-name": "Path 11880",
    d: "M48.923,53.566a10.921,10.921,0,0,1,.045,2.067c1.419.062,3.622-.074,4.594-1.374a2.044,2.044,0,0,0,.334-2.2C52.6,53.252,50.354,53.523,48.923,53.566Z",
    transform: "translate(-17.004 -20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11881",
    "data-name": "Path 11881",
    d: "M34.5,10.241c2.3-.155,3.76-.685,4.231-1.545V5.4A7.427,7.427,0,0,1,34.5,6.62Z",
    transform: "translate(-11.298 -1.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11882",
    "data-name": "Path 11882",
    d: "M28.251,4.522c3.169,0,5.139-.548,5.727-1.58-.15-.624-2.3-1.441-5.727-1.441s-5.577.817-5.727,1.441c.588,1.032,2.558,1.58,5.727,1.58Z",
    transform: "translate(-6.56 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11883",
    "data-name": "Path 11883",
    d: "M9.2,32.6a.281.281,0,0,1-.063-.007,5.994,5.994,0,0,1-1.933-.9c-.436.273-1.9,1.4-.951,3.783a2.448,2.448,0,0,0,.616.889c1.165,1.1,3.32,1.339,4.665,1.374.084-.58.2-1.148.318-1.681a1.812,1.812,0,0,1-.354-.38c-1.005-1.468-.164-4.565.756-6.981a1.852,1.852,0,0,1-.273-.3c-.728-1.05-.564-3.047.468-5.921a1.88,1.88,0,0,1-1.079-.774c-1.077-1.635-.036-5.183,1.169-8.137C10.466,14.68,8.129,16.64,8.1,19.8A7.1,7.1,0,0,0,9.77,21.43a.3.3,0,0,1-.167.555.3.3,0,0,1-.166-.05,7.3,7.3,0,0,1-1.669-1.577,4.1,4.1,0,0,0-.323,4.8.3.3,0,0,1,.034.128A6.679,6.679,0,0,0,9.7,26.837a.3.3,0,0,1-.1.589.3.3,0,0,1-.1-.016,6.878,6.878,0,0,1-2.292-1.545c-.5.943-1.547,3.422.113,5.19.008,0,.018.005.027.011A5.782,5.782,0,0,0,9.267,32a.3.3,0,0,1-.062.6Z",
    transform: "translate(0 -4.772)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11884",
    "data-name": "Path 11884",
    d: "M15.538,20.58a1.483,1.483,0,0,0,1.35.619h6.95V13.29c-2.452-.161-4.016-.738-4.664-1.716a14.87,14.87,0,0,0-2.147.793C15.3,16.406,14.759,19.4,15.538,20.58Zm1.728-3.38a.3.3,0,1,1,.588.141,8.967,8.967,0,0,0-.243,1.438h1.695a.3.3,0,1,1,0,.6H17.3a.3.3,0,0,1-.3-.3A8.08,8.08,0,0,1,17.266,17.2Z",
    transform: "translate(-3.659 -3.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11885",
    "data-name": "Path 11885",
    d: "M26.731,10.241V6.62A7.427,7.427,0,0,1,22.5,5.4V8.7C22.971,9.555,24.431,10.085,26.731,10.241Z",
    transform: "translate(-6.551 -1.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11886",
    "data-name": "Path 11886",
    d: "M34.5,21.2h6.95a1.483,1.483,0,0,0,1.35-.619c.779-1.183.235-4.174-1.489-8.214a14.946,14.946,0,0,0-2.147-.793c-.648.978-2.212,1.556-4.664,1.716Z",
    transform: "translate(-11.298 -3.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11887",
    "data-name": "Path 11887",
    d: "M16.369,51.265c-.4,1.806-.8,4.672.275,6.031a2.084,2.084,0,0,0,1.755.759H24.14V51.407H17.19A2.432,2.432,0,0,1,16.369,51.265Z",
    transform: "translate(-3.96 -19.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11888",
    "data-name": "Path 11888",
    d: "M16.519,39.168c-1.143,3.047-1.433,5.337-.778,6.295a1.371,1.371,0,0,0,1.229.554h6.95V39.369H17.575A2.623,2.623,0,0,1,16.519,39.168Z",
    transform: "translate(-3.741 -14.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11889",
    "data-name": "Path 11889",
    d: "M6.725,52.053a2.044,2.044,0,0,0,.333,2.2c.972,1.3,3.176,1.437,4.6,1.375a11.021,11.021,0,0,1,.045-2.067c-1.43-.043-3.679-.314-4.973-1.512Z",
    transform: "translate(-0.235 -20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11890",
    "data-name": "Path 11890",
    d: "M41.45,51.407H34.5v6.648h5.742A2.086,2.086,0,0,0,42,57.3c1.073-1.359.674-4.225.275-6.031A2.447,2.447,0,0,1,41.45,51.407Z",
    transform: "translate(-11.298 -19.688)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11891",
    "data-name": "Path 11891",
    d: "M34.5,46.017h6.95a1.37,1.37,0,0,0,1.228-.554c.656-.958.366-3.247-.778-6.295a2.618,2.618,0,0,1-1.055.2H34.5Z",
    transform: "translate(-11.298 -14.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11892",
    "data-name": "Path 11892",
    d: "M30.5,7.471V9.906h1.813V7.471c-.293.01-.592.018-.907.018S30.793,7.481,30.5,7.471Z",
    transform: "translate(-9.716 -2.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11893",
    "data-name": "Path 11893",
    d: "M30.5,12.5h1.813V42.719H30.5Z",
    transform: "translate(-9.716 -4.352)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11894",
    "data-name": "Path 11894",
    d: "M17.112,28.473c-1.24,3.4-1,4.858-.574,5.475a1.513,1.513,0,0,0,1.351.585h6.346V28.489h-6.95c-.062,0-.114-.013-.173-.016Zm1.237,2.05a.3.3,0,0,1,.582.163,7.567,7.567,0,0,0-.319,1.741.3.3,0,0,1-.3.293H18.3a.3.3,0,0,1-.292-.312,8.307,8.307,0,0,1,.341-1.884Z",
    transform: "translate(-4.055 -10.671)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPufferCoatIcon);
export default __webpack_public_path__ + "static/media/puffer_coat_icon.a99a48b6fa32bc7e6d4fce596fed6abe.svg";
export { ForwardRef as ReactComponent };